<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      eager
      scrollable
      max-width="1000px"
      content-class="rounded-dialog"
    >
      <v-form ref="MyCoreTimeFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">{{ action }} Core Time</div>

                  <div class="dialog-subtitle">
                    View and mange your core time details.
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-row
                  align="center"
                  justify="space-between"
                  no-gutters
                  class="pa-4"
                >
                  <v-col cols="auto">
                    <div
                      class="metric-card d-flex align-center justify-space-between px-4"
                    >
                      <v-switch
                        v-model="isCompressed"
                        :readonly="action == 'View'"
                        hide-details
                        class="metric-checkbox"
                        color="#147452"
                      />
                      <div class="metric-content">
                        <div class="metric-title">Compressed Work Schedule</div>
                      </div>
                    </div>
                    <div
                      class="metric-card d-flex align-center justify-space-between px-4 my-2"
                    >
                      <v-switch
                        v-model="isRetainer"
                        :readonly="action == 'View'"
                        hide-details
                        class="metric-checkbox"
                        color="#147452"
                      />
                      <div class="metric-content">
                        <div class="metric-title">
                          Retainer
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="auto">
                    <v-btn
                      v-if="action != 'View'"
                      class="btn-save"
                      @click="addSched()"
                      style="width: 130px"
                    >
                      Add Schedule
                    </v-btn>
                  </v-col>
                </v-row>
                <v-col cols="12" class="pt-2 px-4">
                  <div class="global-list-card1">
                    <!-- Header -->
                    <div class="global-list-header1">
                      <div>
                        <div class="global-title">
                          <v-icon size="18" color="#147452" class="mr-2">
                            mdi-calendar-outline </v-icon
                          >Schedule List
                        </div>
                        <div class="global-subtitle">
                          View and manage the assigned schedules.
                        </div>
                      </div>

                      <div class="schedule-count">
                        {{ schedList.length }}
                      </div>
                    </div>

                    <!-- Empty State -->
                    <div v-if="schedList.length === 0" class="schedule-empty">
                      <v-icon size="42" color="grey lighten-1">
                        mdi-calendar-clock-outline
                      </v-icon>

                      <div class="mt-2">No schedules available.</div>
                    </div>

                    <!-- Schedule List -->
                    <div v-else class="schedule-list-body">
                      <div
                        v-for="(item, index) in schedList"
                        :key="index"
                        class="schedule-item-card"
                      >
                        <!-- Top -->
                        <div class="schedule-item-header">
                          <!-- Days -->
                          <div class="schedule-days">
                            <!-- <div class="schedule-label">
                              <v-icon size="15" color="#147452">
                                mdi-calendar-week
                              </v-icon>
                              Days
                            </div> -->

                            <div class="schedule-value">
                              <v-chip
                                v-for="(day, i) in item.workSched"
                                :key="i"
                                small
                                class="ma-1"
                                color="gray lighten-1"
                                text-color="#147452"
                                outlined
                              >
                                {{ day }}
                              </v-chip>
                            </div>
                          </div>

                          <!-- Action -->
                          <v-btn
                            v-if="action != 'View'"
                            icon
                            class="global-btn-save"
                            style="width: 40px"
                            @click="editSched(item, index)"
                          >
                            Edit
                          </v-btn>
                        </div>

                        <!-- Time Schedule -->
                        <div class="schedule-times">
                          <div
                            v-for="(time, i) in item.schedTimeList"
                            :key="i"
                            class="schedule-time-card"
                          >
                            <div class="time-icon">
                              <v-icon color="#ffffff" size="18">
                                mdi-clock-outline
                              </v-icon>
                            </div>

                            <div class="time-content">
                              <div class="time-part">
                                {{ getPart(time.tapTimePartID) }}
                              </div>

                              <div class="time-range">
                                {{ formatTime(time.timeFrom) }} -
                                {{ formatTime(time.timeTo) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" class="mt-4 px-4">
                  <div class="schedule-list-card">
                    <!-- Header -->
                    <div class="schedule-list-header">
                      <div>
                        <div class="global-title">
                          <v-icon size="18" color="#147452" class="mr-2">
                            mdi-calendar-range
                          </v-icon>
                          Calendrical Year
                        </div>

                        <div class="global-subtitle">Select calendar year.</div>
                      </div>
                    </div>

                    <v-row class="pa-4">
                      <v-col cols="12" md="6">
                        <div
                          class="metric-card"
                          :class="{ active: ctdModel.ctType == 1 }"
                        >
                          <v-switch
                            :rules="[formRules.required]"
                            v-model="ctdModel.ctType"
                            :checked="ctdModel.ctType == 1"
                            value="1"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                          />

                          <div class="metric-content">
                            <div class="metric-code">AY</div>
                            <div class="metric-title">Academic Year</div>
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" md="6">
                        <div
                          class="metric-card"
                          :class="{ active: ctdModel.ctType == 2 }"
                        >
                          <v-switch
                            :rules="[formRules.required]"
                            v-model="ctdModel.ctType"
                            :checked="ctdModel.ctType == 2"
                            value="2"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                          />

                          <div class="metric-content">
                            <div class="metric-code">CY</div>
                            <div class="metric-title">Calendar Year</div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  v-if="ctdModel.ctType && ctdModel.ctType == 1"
                  class="mt-4 pt-2 px-4"
                >
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="ctdModel.syID"
                    :rules="
                      ctdModel.ctType && ctdModel.ctType == 1
                        ? [formRules.required]
                        : []
                    "
                    :items="syList"
                    item-value="id"
                    :item-text="getSYItemText"
                    class="rounded-lg"
                    label="School Year"
                    color="#6DB249"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col
                  v-if="ctdModel.ctType && ctdModel.ctType == 1"
                  cols="12"
                  class="px-4"
                >
                  <v-row>
                    <v-col
                      v-for="item in semList"
                      :key="item.id"
                      cols="12"
                      md="4"
                      class="field-spacing"
                    >
                      <div
                        class="metric-card"
                        :class="{ active: ctdModel.sem === item.id }"
                        @click="
                          ctdModel.sem = item.id;
                          changeSem();
                        "
                      >
                        <div
                          class="custom-radio"
                          :class="{ active: ctdModel.sem === item.id }"
                        >
                          <div class="custom-radio-dot"></div>
                        </div>

                        <div class="metric-content">
                          <div>
                            <div class="metric-title">
                              {{ item.title }}
                            </div>

                            <!-- <div class="metric-subtitle">
                              Select {{ item.title.toLowerCase() }} period
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Keep validation without changing your functionality -->
                  <v-radio-group
                    v-model="ctdModel.sem"
                    @change="changeSem()"
                    :rules="[formRules.required]"
                    hide-details
                    class="d-none"
                  >
                    <v-radio
                      v-for="item in semList"
                      :key="'hidden-' + item.id"
                      :value="item.id"
                    />
                  </v-radio-group>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  v-if="ctdModel.ctType"
                  class="mt-4 pt-2 px-4"
                >
                  <v-menu
                    ref="cyFromRef"
                    :close-on-content-click="false"
                    :return-value.sync="ctdModel.cyFrom"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        v-model="ctdModel.cyFrom"
                        :rules="[formRules.required]"
                        chips
                        color="#6DB249"
                        small-chips
                        label="Date (From)"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="#6DB249"
                      v-model="ctdModel.cyFrom"
                      :min="getMinDateFrom"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        color="#6DB249"
                        @click="$refs.cyFromRef.save(ctdModel.cyFrom)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="ctdModel.ctType"
                  cols="12"
                  md="6"
                  class="mt-4 pt-2 px-4"
                >
                  <v-menu
                    ref="cyToRef"
                    :close-on-content-click="false"
                    :return-value.sync="ctdModel.cyTo"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        v-model="ctdModel.cyTo"
                        :rules="[formRules.required]"
                        chips
                        color="#6DB249"
                        small-chips
                        label="Date (To)"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="#6DB249"
                      :min="ctdModel.cyFrom"
                      :max="getMaxDateTo"
                      v-model="ctdModel.cyTo"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        color="#6DB249"
                        @click="$refs.cyToRef.save(ctdModel.cyTo)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!-- <v-col v-if="action == 'Update'" cols="12" class=" pt-2 px-4">
                  <v-select
                    outlined
                    :rules="action == 'Update' ? [formRules.required] : []"
                    :items="statusList"
                    label="Status"
                    color="#93CB5B"
                   
                    v-model="ctdModel.isActive"
                  ></v-select>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-fab-transition v-if="action != 'Add'">
              <v-menu top content-class="rounded-dialog">
                <template v-slot:activator="{ on }">
                  <v-btn
                    :color="$vuetify.theme.themes.light.submitBtns"
                    fab
                    dark
                    left
                    class="v-btn--example"
                    v-on="on"
                    width="44"
                    height="44"
                  >
                    <v-icon>mdi-comment-processing-outline</v-icon>
                  </v-btn>
                </template>

                <v-card
                  class="rounded-dialog mx-auto"
                  width="420"
                  max-width="420"
                  max-height="600"
                >
                  <v-card-title class="dialog-header">
                    <div class="dialog-header-content">
                      <div class="dialog-title-wrapper">
                        <div class="dialog-icon">
                          <v-icon color="white" size="20">
                            mdi-comment-processing-outline
                          </v-icon>
                        </div>

                        <div class="dialog-text">
                          <div class="dialog-title">Remarks</div>
                          <div class="dialog-subtitle">
                            Review all remarks related to this request.
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-text
                    class="remarks-container py-3"
                    style="max-height: 420px; overflow-y: auto"
                  >
                    <v-timeline
                      dense
                      class="remarks-timeline"
                      v-if="remarksData.length > 0"
                    >
                      <v-timeline-item
                        v-for="item in remarksData"
                        :key="item.id"
                        color="#147452"
                        small
                        fill-dot
                        icon="mdi-comment-processing-outline"
                      >
                        <div class="remark-card">
                          <div class="remark-message">
                            {{ item.message }}
                          </div>

                          <div class="remark-footer">
                            <div>
                              <div class="remark-user">
                                {{
                                  $store.getters.getUserData.id ==
                                  item.remarks_maker_userID
                                    ? "You"
                                    : item.remarks_by
                                }}
                              </div>

                              <div class="remark-date">
                                {{ formatDate(item.created_at) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-timeline-item>
                    </v-timeline>

                    <div
                      v-else
                      class="d-flex flex-column align-center justify-center py-10"
                    >
                      <v-icon size="42" color="grey lighten-1">
                        mdi-comment-processing-outline
                      </v-icon>

                      <div class="mt-3 text-subtitle-1 font-weight-medium">
                        No remarks found
                      </div>

                      <div class="text-caption grey--text">
                        There are currently no remarks available.
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-fab-transition>
            <v-spacer></v-spacer>
            <v-btn class="btn-cancel" outlined @click="closeD()">
              Cancel
            </v-btn>
            <v-btn
              class="btn-save"
              v-if="action == 'Add'"
              @click="checkConflict('ADD')"
            >
              Add
            </v-btn>
            <v-btn
              class="btn-save"
              v-if="action == 'Update'"
              @click="checkConflict('UPDATE')"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
    <!-- schedule day of week  -->
    <v-dialog
      v-model="schedDialog"
      eager
      persistent
      scrollable
      max-width="700px"
      content-class="rounded-dialog"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="circle-add" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">
                  {{ schedAction }} Core Time Schedule
                </div>

                <div class="dialog-subtitle">
                  Update your core time schedule details.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeSchedDialog()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text style="max-height: 700px" class="my-4">
          <v-form ref="schedDialogRef" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-autocomplete
                    outlined
                    multiple
                    small-chips
                    required
                    deletable-chips
                    v-model="schedWfh"
                    :rules="[formRules.required]"
                    :items="dayList"
                    item-value="name"
                    item-text="name"
                    class="rounded-lg"
                    label="Work Schedule"
                    color="#6DB249"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="px-4">
                  <div class="global-list-card1">
                    <div class="global-list-header1">
                      <div>
                        <div class="global-title">
                          <v-icon size="18" color="#147452" class="mr-2">
                            mdi-calendar-clock-outline
                          </v-icon>
                          Time Schedule/s
                        </div>
                        <div class="global-subtitle">
                          Manage your assigned schedule times.
                        </div>
                      </div>

                      <v-btn
                        v-if="schedTimeList.length < 2"
                        color="#147452"
                        depressed
                        class="btn-save"
                        @click="addSchedTime()"
                      >
                        Add Time
                      </v-btn>
                    </div>

                    <div
                      v-for="(time, i) in schedTimeList"
                      :key="i"
                      class="schedule-item"
                    >
                      <div class="schedule-info">
                        <div class="schedule-part">
                          {{ getPart(time.tapTimePartID) }}
                        </div>

                        <div class="schedule-time">
                          <v-icon small color="#147452" class="mr-1">
                            mdi-clock-outline
                          </v-icon>

                          {{ formatTime(time.timeFrom) }}
                          <span class="mx-1">–</span>
                          {{ formatTime(time.timeTo) }}
                        </div>
                      </div>

                      <v-btn
                        outlined
                        class="global-btn-save"
                        style="width: 30px"
                        @click="editSchedTime(time, i)"
                      >
                        Edit
                      </v-btn>
                    </div>

                    <div v-if="schedTimeList.length === 0" class="empty-state">
                      <v-icon color="grey lighten-1" size="30">
                        mdi-clock-outline
                      </v-icon>

                      <div>No schedule added yet.</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn class="btn-cancel" outlined @click="closeSchedDialog()">
            Cancel
          </v-btn>
          <v-btn
            class="btn-save"
            outlined
            v-if="schedAction == 'Add'"
            @click="saveSched()"
          >
            Add
          </v-btn>
          <v-btn
            class="btn-save"
            outlined
            v-if="schedAction == 'Update'"
            @click="updateSched()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- schedule time schedules -->
    <v-dialog
      v-model="schedTimeDialog"
      eager
      persistent
      scrollable
      max-width="500px"
      content-class="rounded-dialog"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="circle-add" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">
                  {{ schedTimeAction }} Time Schedule/s
                </div>

                <div class="dialog-subtitle">
                  Fill in the required information below
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeSchedTimeDialog()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text style="max-height: 700px" class="my-4">
          <v-form ref="schedTimeDialogRef" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-autocomplete
                    outlined
                    small-chips
                    @change="changeTime()"
                    required
                    deletable-chips
                    v-model="tapTimePartID"
                    :rules="[formRules.required]"
                    :items="tapTimeList"
                    item-value="id"
                    item-text="title"
                    class="rounded-lg"
                    label="Tap Time"
                    color="#6DB249"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-menu
                    ref="menu"
                    v-model="schedTimeIn"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="timePicker1"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        v-model="timePicker1"
                        :rules="[formRules.required]"
                        color="#6DB249"
                        label="From"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timePicker1"
                      format="ampm"
                      color="green lighten-1"
                      v-model="timePicker1"
                      @click:minute="$refs.menu.save(timePicker1)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-menu
                    ref="menu1"
                    v-model="schedTimeOut"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="timePicker2"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        outlined
                        :rules="[formRules.required]"
                        v-model="timePicker2"
                        color="#6DB249"
                        label="To"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timePicker2"
                      format="ampm"
                      color="green lighten-1"
                      v-model="timePicker2"
                      @click:minute="$refs.menu1.save(timePicker2)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn class="btn-cancel" outlined @click="closeSchedTimeDialog()">
            Cancel
          </v-btn>
          <v-btn
            class="btn-save"
            outlined
            v-if="schedTimeAction == 'Add'"
            @click="saveSchedTime()"
          >
            Add
          </v-btn>
          <v-btn
            class="btn-save"
            outlined
            v-if="schedTimeAction == 'Update'"
            @click="updateSchedTime()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- updating confirmation -->
    <v-dialog
      v-model="confirmSubmissionDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon
              :name="confirmSubmit.error ? 'alert-circle' : 'circle-check'"
            />
          </div>

          <div class="delete-title">
            {{
              confirmSubmit.error ? "Unable to Proceed" : "Confirm Submission?"
            }}
          </div>

          <div
            v-if="!confirmSubmit.error && confirmSubmit.type == 'UPDATE'"
            class="delete-description"
          >
            Are you sure you want to
            <strong>update this core-time</strong>? <br /><br />
            Updated core-time will be subject
            <strong>FOR APPROVAL</strong>.
          </div>

          <div
            v-if="!confirmSubmit.error && confirmSubmit.type == 'ADD'"
            class="delete-description"
          >
            Are you sure you want to
            <strong>add this core-time</strong>? <br /><br />
            Added core-time will be subject
            <strong>FOR APPROVAL</strong>.
          </div>

          <div
            v-if="
              confirmSubmit.error &&
                (confirmSubmit.type == 'ADD' || confirmSubmit.type == 'UPDATE')
            "
            class="delete-description"
          >
            {{ confirmSubmit.msg }}
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="submitBtnLoading"
            @click="confirmSubmissionDialog = false"
          >
            {{ confirmSubmit.error ? "Close" : "Cancel" }}
          </v-btn>

          <v-spacer></v-spacer>

          <!-- UPDATE -->
          <v-btn
            v-if="!confirmSubmit.error && confirmSubmit.type == 'UPDATE'"
            color="#147452"
            depressed
            class="btn-save"
            :loading="submitBtnLoading"
            :disabled="submitBtnLoading"
            @click="updateCoreTime()"
          >
            Confirm
          </v-btn>

          <!-- ADD -->
          <v-btn
            v-if="!confirmSubmit.error && confirmSubmit.type == 'ADD'"
            color="#147452"
            depressed
            class="btn-save"
            :loading="submitBtnLoading"
            :disabled="submitBtnLoading"
            @click="addnew()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->
    <v-dialog v-model="dialogAlert" max-width="400" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="headline font-weight-bold">
          Information
          <v-icon size="30" color="info"> mdi-information </v-icon>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text class="py-4">
          <div class="text-justify">
            Your selected core time does not meet the minimum required
            <strong>40 hours</strong>. Please update your time selection to
            reach at least <strong>40 hours</strong>.
          </div>

          <div class="mt-4 text-center">
            <v-chip color="info" dark medium>
              Total Counted Hours: {{ totalHours }} Hours
            </v-chip>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <!-- Actions -->
        <v-card-actions class="justify-end">
          <!-- <v-btn text color="grey" @click="dialog = false">
            Cancel
          </v-btn> -->

          <v-btn color="error" dark @click="dialogAlert = false"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
    action: null,
  },
  data() {
    return {
      remarksData: [],
      dialogAlert: false,
      confirmSubmissionDialog: false,
      submitBtnLoading: false,
      schedTimeDialog: false,
      schedTimeAction: null,
      schedDialog: false,
      schedTimeIn: null,
      schedTimeOut: null,
      schedWfh: null,
      schedAction: null,
      isCompressed: false,
      isRetainer: false,
      schedIndexToUpdate: null,
      timeSchedIndexToUpdate: null,

      schedList: [],
      schedTimeList: [],
      tempSelectedDays: [],
      dialog: false,
      timePicker1: null,
      timePicker2: null,
      ctdModel: {
        id: null,

        workSched: null,
        name: null,
        empID: null,
        coreTimeFrom: null,
        coreTimeTo: null,
        syID: null,
        status: null,
        ctType: null,
        cyFrom: null,
        cyTo: null,
        sem: null,
        isActive: null,
      },
      directHeadUser: null,
      syList: [],

      ctd_headers: [
        {
          text: "Work Schedule",
          value: "workSched",
          align: "start",
        },
        // { text: "Part", value: "part", align: "center" },
        {
          text: "Time Schedule/s",
          value: "schedTimeList",
          align: "center",
          width: 300,
        },

        {
          text: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: 200,
        },
      ],
      statusList: ["Active", "Inactive"],
      semList: [
        { id: 1, title: "First Semester" },
        { id: 2, title: "Second Semester" },
        { id: 3, title: "Summer" },
      ],

      tapTimeList: [
        { id: 1, title: "First Part" },
        { id: 2, title: "Second Part" },
        // { id: 3, title: "Overtime" },
      ],
      tapTimePartID: null,
      designationList: [],
      officeList: [],
      dayList: [
        // { name: "N/A", disabled: false },
        { name: "Monday", disabled: false },
        { name: "Tuesday", disabled: false },
        { name: "Wednesday", disabled: false },
        { name: "Thursday", disabled: false },
        { name: "Friday", disabled: false },
        { name: "Saturday", disabled: false },
        { name: "Sunday", disabled: false },
      ],
      yearSelection: [],
      confirmSubmit: {
        error: false,
        msg: null,
        type: null,
        show: false,
      },

      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  computed: {
    getMinDateFrom() {
      let min;
      let monthArr = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];
      let d = new Date();
      if (this.ctdModel.ctType && this.ctdModel.ctType == 1) {
        if (this.ctdModel.sem == 1) {
          //min is july
          min = d.getFullYear() + "-" + monthArr[6] + "-01";
        } else if (this.ctdModel.sem == 2) {
          //min is january of current uear
          min = d.getFullYear() + "-" + monthArr[0] + "-01";
        } else if (this.ctdModel.sem == 3) {
          //min is june
          min = d.getFullYear() + "-" + monthArr[5] + "-01";
        }
      } else if (this.ctdModel.ctType && this.ctdModel.ctType == 2) {
        min = d.getFullYear() + "-" + monthArr[0] + "-01";
      }
      return min;
    },
    getMaxDateTo() {
      let max;
      let monthArr = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];
      let d = new Date();
      let cyDateFrom;
      if (this.ctdModel.cyFrom) {
        cyDateFrom = new Date(this.ctdModel.cyFrom);
      }
      if (this.ctdModel.ctType && this.ctdModel.ctType == 1) {
        if (this.ctdModel.sem == 1) {
          //max is december current year
          if (this.ctdModel.cyFrom) {
            max = cyDateFrom.getFullYear() + "-" + monthArr[11] + "-31";
          } else {
            max = d.getFullYear() + "-" + monthArr[11] + "-31";
          }
        } else if (this.ctdModel.sem == 2) {
          //max is june of current year
          if (this.ctdModel.cyFrom) {
            max = cyDateFrom.getFullYear() + "-" + monthArr[5] + "-31";
          } else {
            max = d.getFullYear() + "-" + monthArr[5] + "-31";
          }
        } else if (this.ctdModel.sem == 3) {
          //max is june
          if (this.ctdModel.cyFrom) {
            max = cyDateFrom.getFullYear() + "-" + monthArr[6] + "-31";
          } else {
            max = d.getFullYear() + "-" + monthArr[6] + "-31";
          }
        }
      } else if (this.ctdModel.ctType && this.ctdModel.ctType == 2) {
        if (this.ctdModel.cyFrom) {
          max = cyDateFrom.getFullYear() + "-" + monthArr[11] + "-31";
        } else {
          max = d.getFullYear() + "-" + monthArr[11] + "-31";
        }
      }
      return max;
    },
    totalHours() {
      let total = 0;

      this.schedList.forEach((sched) => {
        let dailyHours = 0;

        sched.schedTimeList.forEach((time) => {
          if (!time.timeFrom || !time.timeTo) return;

          const start = this.convertToHours(time.timeFrom);
          const end = this.convertToHours(time.timeTo);

          dailyHours += end - start;
        });

        // multiply by number of selected days
        total += dailyHours * sched.workSched.length;
      });

      return total;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;

        this.$refs.MyCoreTimeFormref.resetValidation();
        if (data.id) {
          this.initialize();
          this.loadRemarks(data.id);
          this.ctdModel.syID = data.syID;
          this.isCompressed = data.isCompressed || false;
          this.isRetainer = data.isRetainer || false;
          this.schedList = data.coreTimeSched ? data.coreTimeSched : [];
          this.ctdModel.id = data.id;
          this.ctdModel.ctType = data.ctType;
          this.ctdModel.cyFrom = data.cyFrom;
          this.ctdModel.cyTo = data.cyTo;
          this.ctdModel.status = data.status;
          this.getEmpDetails();
          this.ctdModel.sem = data.sem;
          this.ctdModel.isActive = data.isActive ? "Active" : "Inactive";
          this.timePicker1 = "08:00";
          this.timePicker2 = "12:00";
          this.computeDaylist();
        } else {
          this.initialize();
          this.getEmpDetails();
          this.schedWfh = null;
          this.schedList = [];
          this.schedTimeList = [];
          this.ctdModel.syID = null;
          this.ctdModel.ctType = null;
          this.ctdModel.cyFrom = null;
          this.ctdModel.cyTo = null;
          this.ctdModel.status = null;
          this.ctdModel.sem = null;
          this.ctdModel.isActive = null;
        }
      },
      deep: true,
    },
  },

  methods: {
    initialize() {
      this.getDirectHead();
      this.getOffices();
      this.getSchoolYear();
      this.getDesignations();
      this.loadYearSelection();
      //   this.getEmpStatus();
      //   this.getInstitutes();
      //   this.getUserType();
    },
    convertToHours(time) {
      if (!time) return 0;
      let [hourMinute, period] = time.split(" ");
      let [hours, minutes] = hourMinute.split(":").map(Number);

      if (period === "PM" && hours !== 12) {
        hours += 12;
      }

      if (period === "AM" && hours === 12) {
        hours = 0;
      }

      let data = hours + minutes / 60;
      console.log(data);
      return data;
    },
    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/CORETIME", "GET").then((res) => {
          if (res.data) {
            console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },

    changeSem() {
      this.ctdModel.cyFrom = null;
      this.ctdModel.cyTo = null;
    },

    getSYItemText(item) {
      return `${item.syFrom} - ${item.syTo}`;
    },
    getPart(id) {
      let prt;
      for (let i = 0; i < this.tapTimeList.length; i++) {
        if (this.tapTimeList[i].id == id) {
          prt = this.tapTimeList[i].title;
        }
      }
      return prt;
    },

    computeDaylist() {
      let days = [];
      for (let i = 0; i < this.schedList.length; i++) {
        let el = this.schedList[i].workSched;
        for (let j = 0; j < el.length; j++) {
          days.push(el[j]);
        }
      }

      // setting disabled property
      if (days.length > 0) {
        for (let i = 0; i < days.length; i++) {
          for (let j = 0; j < this.dayList.length; j++) {
            let dayListName = this.dayList[j].name;
            if (days[i] == dayListName) {
              this.dayList[j].disabled = true;
            }
          }
        }
      } else {
        for (let i = 0; i < this.dayList.length; i++) {
          this.dayList[i].disabled = false;
        }
      }
    },

    loadYearSelection() {
      let d = new Date();

      for (let i = parseInt(d.getFullYear()); i >= 2021; i--) {
        this.yearSelection.push(i);
      }
    },

    closeSchedDialog() {
      this.$refs.schedDialogRef.resetValidation();
      this.schedDialog = false;
    },

    closeSchedTimeDialog() {
      this.$refs.schedTimeDialogRef.resetValidation();
      this.schedTimeDialog = false;
    },

    addSched() {
      this.schedDialog = true;
      this.schedTimeList = [];
      this.schedAction = "Add";
      this.$refs.schedDialogRef.resetValidation();
      this.computeDaylist();
      this.schedWfh = null;
    },
    editSched(item, index) {
      this.schedIndexToUpdate = index;
      this.schedWfh = item.workSched;
      this.schedTimeList = item.schedTimeList;
      for (let i = 0; i < item.workSched.length; i++) {
        let el = item.workSched[i];
        for (let j = 0; j < this.dayList.length; j++) {
          if (el == this.dayList[j].name) {
            this.dayList[j].disabled = false;
          }
        }
      }

      this.timePicker1 = item.timeIn;
      this.timePicker2 = item.timeOut;

      this.schedAction = "Update";
      this.schedDialog = true;
    },

    updateSched() {
      if (this.$refs.schedDialogRef.validate()) {
        this.schedList[this.schedIndexToUpdate].workSched = this.schedWfh;
        this.schedList[this.schedIndexToUpdate].timeIn = this.timePicker1;
        this.schedList[this.schedIndexToUpdate].timeOut = this.timePicker2;
        this.computeDaylist();
        this.schedDialog = false;
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill up all fields!";
      }
    },

    addSchedTime() {
      this.schedTimeDialog = true;
      //   this.timePicker1 = "08:00";
      //   this.timePicker2 = "12:00";
      this.schedTimeAction = "Add";
      this.$refs.schedTimeDialogRef.reset();
      this.$refs.schedTimeDialogRef.resetValidation();
    },

    changeTime() {
      if (this.tapTimePartID == 1) {
        this.timePicker1 = "08:00";
        this.timePicker2 = "12:00";
      } else if (this.tapTimePartID == 2) {
        this.timePicker1 = "13:00";
        this.timePicker2 = "17:00";
      } else if (this.tapTimePartID == 3) {
        this.timePicker1 = "17:00";
        this.timePicker2 = "22:00";
      }
    },

    editSchedTime(time, index) {
      console.log(time, index);
      this.timeSchedIndexToUpdate = index;

      this.timePicker1 = time.timeFrom;
      this.timePicker2 = time.timeTo;
      this.schedTimeAction = "Update";
      this.tapTimePartID = time.tapTimePartID;
      this.schedTimeDialog = true;
    },

    saveSchedTime() {
      if (this.$refs.schedTimeDialogRef.validate()) {
        this.schedTimeList.push({
          tapTimePartID: this.tapTimePartID,
          timeFrom: this.timePicker1,
          timeTo: this.timePicker2,
        });
        console.log(this.schedTimeList);
        this.schedTimeDialog = false;
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill up all fields!";
      }
    },

    updateSchedTime() {
      if (this.$refs.schedTimeDialogRef.validate()) {
        this.schedTimeList[
          this.timeSchedIndexToUpdate
        ].tapTimePartID = this.tapTimePartID;
        this.schedTimeList[
          this.timeSchedIndexToUpdate
        ].timeFrom = this.timePicker1;
        this.schedTimeList[
          this.timeSchedIndexToUpdate
        ].timeTo = this.timePicker2;
        this.timeSchedIndexToUpdate = null;
        this.schedTimeDialog = false;
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill up all fields!";
      }
    },

    saveSched() {
      if (this.$refs.schedDialogRef.validate()) {
        if (this.schedTimeList.length > 0) {
          this.schedList.push({
            workSched: this.schedWfh,
            schedTimeList: this.schedTimeList,
            // timeIn: this.timePicker1,
            // timeOut: this.timePicker2,
          });
          console.log("this.schedList", this.schedList);
          console.table(
            this.schedList.map((item) => ({
              workSched: item.workSched.join(", "),
              schedTimeList: item.schedTimeList.join(", "),
            })),
          );
          this.schedTimeList = [];
          this.schedDialog = false;
          this.computeDaylist();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please add time schedule/s!";
        }
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill up all fields!";
      }
    },

    getUserType() {
      this.axiosCall("/user-type/getAllUsertype", "GET").then((res) => {
        if (res.data) {
          this.usertypeList = res.data;
        }
      });
    },
    closeD() {
      this.confirmSubmissionDialog = false;
      this.confirmSubmit.type = null;
      this.confirmSubmit.error = false;
      this.confirmSubmit.msg = null;
      this.eventHub.$emit("closeCoreTimeDesignationDialog", false);
      this.dialog = false;
    },
    addnew() {
      if (this.$refs.MyCoreTimeFormref.validate()) {
        this.submitBtnLoading = true;
        let data = {
          coreTimeSched: this.schedList,
          // designationID: this.ctdModel.designationID,
          ctType: this.ctdModel.ctType,
          cyFrom: this.ctdModel.cyFrom,
          cyTo: this.ctdModel.cyTo,
          syID: this.ctdModel.syID,
          sem: this.ctdModel.sem,
          approval_user_detailID: this.directHeadUser,
          employeeID: this.ctdModel.empID,
          isCompressed: this.isCompressed,
          isRetainer: this.isRetainer,
          // isActive: this.ctdModel.isActive == "Active" ? true : false,
        };

        this.axiosCall("/my-core-time", "POST", data).then((res) => {
          this.submitBtnLoading = false;
          if (res.data.status == 201) {
            this.dialog = false;

            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.$refs.MyCoreTimeFormref.reset();

            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    checkConflict(type) {
      if (this.$refs.MyCoreTimeFormref.validate()) {
        if (this.schedList.length > 0) {
          if (this.totalHours >= 40 && this.isRetainer == false) {
            let data = {
              ctType: this.ctdModel.ctType,
              cyFrom: this.ctdModel.cyFrom,
              cyTo: this.ctdModel.cyTo,
              syID: this.ctdModel.syID,
              sem: this.ctdModel.sem,
              id: this.ctdModel.id,
            };
            this.axiosCall("/my-core-time/checkConflict", "POST", data).then(
              (res) => {
                console.log(res.data);
                this.confirmSubmissionDialog = true;
                if (res.data.status == 200) {
                  this.confirmSubmit.error = false;
                  this.confirmSubmit.type = type;
                } else if (res.data.status == 400) {
                  this.confirmSubmit.error = true;
                  this.confirmSubmit.type = type;
                  this.confirmSubmit.msg = res.data.msg;
                }
              },
            );
          } else if (this.isRetainer == true) {
            let data = {
              ctType: this.ctdModel.ctType,
              cyFrom: this.ctdModel.cyFrom,
              cyTo: this.ctdModel.cyTo,
              syID: this.ctdModel.syID,
              sem: this.ctdModel.sem,
              id: this.ctdModel.id,
            };
            this.axiosCall("/my-core-time/checkConflict", "POST", data).then(
              (res) => {
                console.log(res.data);
                this.confirmSubmissionDialog = true;
                if (res.data.status == 200) {
                  this.confirmSubmit.error = false;
                  this.confirmSubmit.type = type;
                } else if (res.data.status == 400) {
                  this.confirmSubmit.error = true;
                  this.confirmSubmit.type = type;
                  this.confirmSubmit.msg = res.data.msg;
                }
              },
            );
          } else {
            this.dialogAlert = true;
            // this.fadeAwayMessage.show = true;
            // this.fadeAwayMessage.type = "error";
            // this.fadeAwayMessage.header = "System Message";
            // this.fadeAwayMessage.message =
            //   "Your selected core time does not meet the minimum required 40 hours. Please update your time selection to reach at least 40 hours.";
          }
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "No time schedules found!";
        }

        // this.confirmUpdateDialog = true;
      }
    },

    updateCoreTime() {
      this.submitBtnLoading = true;
      // if (this.$refs.MyCoreTimeFormref.validate()) {
      let data = {
        coreTimeSched: this.schedList,
        // designationID: this.ctdModel.designationID,
        ctType: this.ctdModel.ctType,

        cyFrom: this.ctdModel.cyFrom,
        cyTo: this.ctdModel.cyTo,

        syID: this.ctdModel.syID,
        sem: this.ctdModel.sem,
        employeeID: this.ctdModel.empID,
        isCompressed: this.isCompressed,
        isRetainer: this.isRetainer,
        // isActive: this.ctdModel.isActive == "Active" ? true : false,
      };

      this.axiosCall("/my-core-time/" + this.ctdModel.id, "PATCH", data).then(
        (res) => {
          this.submitBtnLoading = false;
          if (res.data.status == 200) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.$refs.MyCoreTimeFormref.reset();
            this.confirmSubmissionDialog = false;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
      // }
    },

    getSchoolYear() {
      this.axiosCall("/school-year", "GET").then((res) => {
        console.log(res.data);
        this.syList = res.data;
      });
    },

    getDirectHead() {
      this.axiosCall("/my-direct-head/getMyDirectHead", "GET").then((res) => {
        if (res.data) {
          this.directHeadUser = res.data[0].userID;
        }
      });
    },

    getEmpDetails() {
      this.axiosCall("/employee/my-details", "GET").then((res) => {
        console.log(res.data);
        this.ctdModel.assigned_office = res.data.officeID;
      });
    },

    getOffices() {
      this.axiosCall("/offices", "GET").then((res) => {
        this.officeList = res.data;
      });
    },
    getPositions() {
      this.axiosCall("/positions", "GET").then((res) => {
        this.positionList = res.data;
      });
    },
    getDesignations() {
      this.axiosCall("/designations", "GET").then((res) => {
        this.designationList = res.data;
      });
    },
    getEmpStatus() {
      this.axiosCall("/employment-status", "GET").then((res) => {
        this.empStatusList = res.data;
      });
    },
    getInstitutes() {
      this.axiosCall("/institutes", "GET").then((res) => {
        this.instituteList = res.data;
      });
    },
  },
};
</script>

<style>
.schedule-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  border-bottom: 1px solid #edf1f5;
  background: #fafbfc;
}

.schedule-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  transition: 0.2s;
}

.schedule-item:not(:last-child) {
  border-bottom: 1px solid #f2f4f7;
}

.schedule-item:hover {
  background: #f8faf8;
}

.schedule-info {
  display: flex;
  flex-direction: column;
}

.schedule-part {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}

.schedule-time {
  margin-top: 6px;
  display: flex;
  align-items: center;
  color: #6b7280;
  font-size: 14px;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #9ca3af;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}
.schedule-list-card {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: hidden;
}

.schedule-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #edf2f7;
  background: #fafbfc;
}

.schedule-count {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #147452;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.schedule-item-card {
  padding: 16px;
  transition: 0.25s;
  margin-bottom: 16px;
  background: #fff;
}

.schedule-item-card:last-child {
  margin-bottom: 0;
}

.schedule-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #eef2f7;
}

.schedule-days {
  flex: 1;
}

.schedule-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #7b8794;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.schedule-value {
  font-size: 15px;
  font-weight: 500;
  color: #374151;
}

.schedule-times {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.schedule-time-card {
  display: flex;
  align-items: center;
  background: #f8fafb;
  border: 1px solid #edf2f7;
  border-radius: 10px;
  padding: 12px;
}

.schedule-empty {
  text-align: center;
  padding: 50px 20px;
  color: #9ca3af;
}
.time-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #147452;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
}

.time-content {
  flex: 1;
}

.time-part {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.time-range {
  margin-top: 3px;
  font-size: 13px;
  color: #6b7280;
}
</style>
